<template>
  <v-dialog
      v-model="dialogVisible"
      max-width="800px"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs"/>
    </template>
    <v-form v-model="valid" @submit.prevent="save">
      <v-card>
        <v-card-title>
          <span v-if="data.id" class="text-h5">Upravit zábor/vjezd</span>
          <span v-else class="text-h5">Přidat zábor/vjezd</span>
        </v-card-title>

        <v-card-text>

          <map-picker
              :latitude.sync="data.latitude"
              :longitude.sync="data.longitude"
            />
          <v-btn block color="primary" @click="useDevicePosition" :loading="!!watchLocationId">
            <v-icon dark>
              mdi-crosshairs-gps
            </v-icon>
            Použít polohu zařízení
          </v-btn>

          <v-text-field
              v-model="data.address"
              label="Adresa/Parcelní číslo"
          />
          <v-text-field
              v-model="data.description"
              label="Popis/Typ záboru"
          />
          <v-text-field
              v-model="data.name"
              label="Jméno žadatele"
          />
          <v-row>
            <v-col>
              <date-field
                  v-model="data.validfrom"
                  label="Platí od"
              />
            </v-col>
            <v-col>
              <date-field
                  v-model="data.validto"
                  label="Platí do"
              />
            </v-col>
          </v-row>
          <file-field
              v-model="data.finding"
              label="Zjištění MP"
          />
          <file-field
              v-model="data.request"
              label="Žádost"
          />
          <file-field
              v-model="data.stand"
              label="Stanovisko MPO"
          />
          <file-field
              v-model="data.decision"
              label="Rozhodnutí DPO"
          />
          <v-radio-group v-model="data.paid">
            <v-radio value="paid" label="Zaplaceno"/>
            <v-radio value="notpaid" label="Nezaplaceno"/>
            <v-radio value="notrequired" label="Bez poplatku"/>
          </v-radio-group>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="blue darken-1"
              text
              @click="close"
          >
            Zrušit
          </v-btn>
          <v-btn
              type="submit"
              color="blue darken-1"
              text
              :disabled="!valid"
          >
            Uložit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import DateField from "@/components/DateField";
import FileField from "@/components/FileField";
import {api, defaultApiErrorHandler} from "@/main";
import MapPicker from "@/components/MapPicker";
import {extensionToJpg, resizeImage} from "@/images";

export default {
  name: "ItemForm",
  components: {MapPicker, FileField, DateField},
  props: {
    id: String,
  },

  watch: {
    id: function (id) {
      if (this.watchLocationId) {
        navigator.geolocation.clearWatch(this.watchLocationId);
        this.watchLocationId = null;
      }
      if (!id || id === '0') {
        this.data = { ...this.newData };
        return;
      }
      api
          .get('item.php', { params: { id: id } })
          .then(response => {
            console.log('loaded item data', response);
            this.data = response.data;
            this.dialogVisible = true;
          })
          .catch(defaultApiErrorHandler);
    },
    dialogVisible: function (isVisible) {
      if (!isVisible) {
        this.$emit('closed');
      }
    },
  },

  data: () => ({
    dialogVisible: false,
    valid: false,
    data: {
      latitude: null,
      longitude: null,
    },
    newData: {
      address: "",
      description: "",
      name: "",
      latitude: null,
      longitude: null,
      finding: null,
      request: null,
      stand: null,
      decision: null,
      paid: 'notpaid',
    },
    center: {
      lat: 48.940340739487645,
      lng: 16.73700009282884,
    },
    watchLocationId: null,
    locationLoading: false,
  }),

  created() {
    this.data = { ...this.newData };
  },

  methods: {
    close () {
      this.dialogVisible = false;
      this.data = { ...this.newData };
    },

    async save () {
      let data = { ...this.data };
      console.log('saving', data);
      let formData = new FormData();
      for (const field of ['request', 'stand', 'decision']) {
        if (data[field]) {
          if (data[field].uploadFile) {
            formData.append(field, data[field].uploadFile, data[field].uploadFile.name);
          }
          data[field] = data[field].file; // keep current value when no upload
        }
      }
      if (data.finding) {
        if (data.finding.uploadFile) {
          console.log('data.finding', data.finding);
          try {
            let resizedImage = await resizeImage(data.finding.uploadFile, 1500);
            formData.append('finding', resizedImage, extensionToJpg(data.finding.uploadFile.name));
          } catch (e) {
            console.error('Resizing finding image failed', e);
            alert('Selhalo zmenšování fotografie Zjištění MP: '+e);
            return;
          }
        }
        data.finding = data.finding.file; // keep current value when no upload
      }
      formData.append("json", JSON.stringify(data));
      api
          .post('item.php', formData)
          .then(response => {
            console.log('saved', response);
            this.$emit('updated');
            this.close()
          })
          .catch(defaultApiErrorHandler);
    },

    useDevicePosition () {
      this.watchLocationId = navigator.geolocation.watchPosition( (position) => {
        console.log('position', position.coords);
        this.data.latitude = position.coords.latitude.toString();
        this.data.longitude = position.coords.longitude.toString();
        navigator.geolocation.clearWatch(this.watchLocationId);
        this.watchLocationId = null;
      }, (err) => {
        console.warn('geolocation error', err);
        navigator.geolocation.clearWatch(this.watchLocationId);
        this.watchLocationId = null;
      }, {
        enableHighAccuracy: true
      });
    }
  },
}
</script>
